import React, { Component } from 'react';
import { connect } from 'react-redux';
import gifImg from 'assets/images/gif.gif';
class LiveScore extends Component {
    render() {        
        return( 
            <div className="card">
            <div className="header">
              <h4 className="title">Live Scores</h4>
              <p className="category"></p>
            </div>
            <div className="content table-responsive table-full-width">
              <table className="table table-hover table-striped">
                <thead>
                  <tr>
                  <th>Court</th>
                  <th>Home (Score)</th>
                    <th>Visitor (Score)</th>
                  </tr>
                </thead>
                <tbody>
                {this.renderList()}
                </tbody>
              </table>
    
            </div>
          </div>
        );
    }

    renderList = () => {
        return this.props.score.sort(function(a, b) {
            return a.courtNo - b.courtNo;
          }).map(({id, courtNo, homeTeamName, homeTeamScore, visitorTeamName, visitorTeamScore}) => {
            return <tr key={id}>
            <td>
                {courtNo}
            </td>
             <td>
               <div>{homeTeamName}</div>
               <div><h6> {homeTeamScore}</h6></div>
             </td>
             <td>
               <div>{visitorTeamName}</div>
               <div><h6> {visitorTeamScore}</h6></div>
             </td>
             <td>
               <div><img src={gifImg} width={50} height={50}></img></div>
             </td>
           </tr>;
        });
    }
} 

const mapStateToProps = state => {
    return { score: state.score };
}

export default connect(mapStateToProps)(LiveScore);


// WEBPACK FOOTER //
// ./src/pages/Scores/index.js